import styled from 'styled-components';
import { textTransform } from 'utils';

export const TechnologyDetailsWrapper = styled.div.attrs({
  className: 'technology-details'
})`
  width: 80%;
  margin: 0 auto;

  .technology-details__header {
    margin-top: 28px;
    h1 {
      font-weight: 450;
      font-size: 24px;
      line-height: 34px;
      letter-spacing: 1.5px;
      text-transform: ${textTransform};
    }
    h2 {
      font-weight: 420;
      font-size: 20px;
      line-height: 34px;
      letter-spacing: 1.5px;
      text-transform: ${textTransform};
    }
  }

  .technology-details__image-wrapper {
    margin-top: 20px;
  }

  .technology-details__description {
    margin-top: 22px;

    & > ol {
      & > li {
        list-style: decimal;
        display: list-item;

        & > ul {
          & > li {
            list-style: circle;
            display: list-item;

            display: flex;
            align-items: flex-start;
            margin-top: 8px;

            &:before {
              content: '';
              flex-shrink: 0;
              width: 24px;
              height: 24px;
              padding: 5px;
              margin-right: 8px;
              background-image: url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 78.369 78.369'%3E%3Cpath fill='%23de1619' d='M78.049 19.015L29.458 67.606a1.094 1.094 0 0 1-1.548 0L.32 40.015a1.094 1.094 0 0 1 0-1.547l6.704-6.704a1.095 1.095 0 0 1 1.548 0l20.113 20.112 41.113-41.113a1.095 1.095 0 0 1 1.548 0l6.703 6.704a1.094 1.094 0 0 1 0 1.548z'/%3E%3C/svg%3E");
              background-repeat: no-repeat;
              background-origin: content-box;
            }
          }
        }
      }
    }

    & > ul {
      & > li {
        display: list-item;

        margin-top: 8px;
        margin-left: 27px;
        position: relative; 

        &:before {
          content: '';
          flex-shrink: 0;
          width: 24px;
          height: 24px;
          padding: 5px;
          margin-right: 8px;
          background-image: url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 78.369 78.369'%3E%3Cpath fill='%23de1619' d='M78.049 19.015L29.458 67.606a1.094 1.094 0 0 1-1.548 0L.32 40.015a1.094 1.094 0 0 1 0-1.547l6.704-6.704a1.095 1.095 0 0 1 1.548 0l20.113 20.112 41.113-41.113a1.095 1.095 0 0 1 1.548 0l6.703 6.704a1.094 1.094 0 0 1 0 1.548z'/%3E%3C/svg%3E");
          background-repeat: no-repeat;
          background-origin: content-box;
          top: 0;
          position: absolute;
          right: 100%;
        }
      }
    }
  }
  .technology-details__description p:last-child a{
    color: #de1619;
    text-decoration:underline;
  }

  .technology-details__carousel-wrapper {
    display: flex;
    /* justify-content: start; */
    margin: 30px 0 97px;

    .technology-details__carousel {
      padding: 22px 1px;
      background: #2d2d2d;
      /* width: 75vw; */

      @media (min-width: 768px) {
        width: 55vw;
      }

      .technology-details__carousel-item-wrapper {
        margin: 0 8px;
        .technology-details__carousel-item {
          display: flex;
          flex-direction: column;
          cursor: pointer;

          .technology-details__carousel-item-image {
            width: 304px;
            height: 441px;
          }

          h3 {
            font-weight: 390;
            font-size: 16px;
            line-height: 24px;
            color: #979797;
            margin-top: 11px;
          }
          h2 {
            display: table-cell;
            flex: 1;
            font-weight: 450;
            font-size: 20px;
            line-height: 22px;
            letter-spacing: 1.5px;
            text-transform: ${textTransform};
            margin-top: 9px;
          }
          .technology-details__carousel-item-description {
            font-weight: 390;
            font-size: 16px;
            line-height: 24px;
            color: #979797;
            margin-top: 9px;
            max-width: 282px;
          }
        }
      }
    }

    .technology-details__movies-wrapper {
      padding: 22px 1px;
      background: #2d2d2d;

      .technology-details__carousel-item-wrapper {
        margin: 0 8px;
        .technology-details__carousel-item {
          display: flex;
          flex-direction: column;
          cursor: pointer;

          .technology-details__carousel-item-image {
            width: 304px;
            height: 441px;
          }

          h3 {
            font-weight: 390;
            font-size: 16px;
            line-height: 24px;
            color: #979797;
            margin-top: 11px;
          }
          h2 {
            display: table-cell;
            flex: 1;
            font-weight: 450;
            font-size: 20px;
            line-height: 22px;
            letter-spacing: 1.5px;
            text-transform: ${textTransform};
            margin-top: 9px;
          }
          .technology-details__carousel-item-description {
            font-weight: 390;
            font-size: 16px;
            line-height: 24px;
            color: #979797;
            margin-top: 9px;
            max-width: 282px;
          }
        }
      }
    }
  }
`;

export default TechnologyDetailsWrapper;
